"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _globals = require("@insided/shared/utils/globals");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'powered-by-insided';
exports.cssAnchorName = cssAnchorName;

var scrollToTop = function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

var PoweredByInsided = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PoweredByInsided, _Component);

  var _super = _createSuper(PoweredByInsided);

  function PoweredByInsided() {
    var _this;

    (0, _classCallCheck2.default)(this, PoweredByInsided);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showScrollTop: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScroll", function () {
      _this.setState({
        showScrollTop: window.scrollY > 0
      });
    });
    return _this;
  }

  (0, _createClass2.default)(PoweredByInsided, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "render",
    value: function render(props) {
      var _this2 = this;

      return (0, _preact.h)(_globals.ModulesContext.Consumer, null, function (modules) {
        var isCookieBannerEnabled = modules.includes('cookiebar') && !props.cookieConfig.use_external_modal;
        var poweredByDescription = 'Powered by Gainsight';
        var externalLink = 'https://www.gainsight.com/customer-communities/';
        var icon = 'logo-gainsight';
        var title = 'Visit Gainsight.com';
        return (0, _preact.h)("div", {
          className: "Template-footer"
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('sitewidth', 'box', 'box--blend')
        }, (0, _preact.h)("div", {
          className: "templatefoot"
        }, (0, _preact.h)(_phrase.default, {
          p: "accessibility_label.powered_by_gainsight",
          renderAsText: true
        }, function (accessibilityLabel) {
          return (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)(externalLink),
            className: icon,
            title: title,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": accessibilityLabel
          }, (0, _preact.h)("span", {
            className: "is-hidden"
          }, poweredByDescription));
        })), (0, _preact.h)("div", {
          className: "templatefoot-privacy-links"
        }, (0, _preact.h)(_phrase.default, {
          p: "Terms & Conditions",
          renderAsText: true
        }, function (termsAndConditionsPhrase) {
          return (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)(props.termsConditions),
            "aria-label": termsAndConditionsPhrase
          }, termsAndConditionsPhrase);
        }), isCookieBannerEnabled && (0, _preact.h)(_phrase.default, {
          p: "cookiepolicy.link",
          renderAsText: true
        }, function (ariaLabel) {
          return (0, _preact.h)("button", {
            type: "button",
            className: "templatefoot-privacy-link-button",
            onClick: function onClick() {
              return (0, _globals.publish)('edit_cookie_settings', null);
            },
            "aria-label": ariaLabel
          }, ariaLabel);
        }), (0, _preact.h)("a", {
          href: "https://www.gainsight.com/policy/accessibility-cc/",
          target: "_blank",
          rel: "noreferrer"
        }, "Accessibility statement")), (0, _preact.h)(_phrase.default, {
          p: "branded.back_to_top",
          renderAsText: true
        }, function (phrase) {
          return (0, _preact.h)(_Button.default, {
            className: (0, _classnames.default)('scroll-to-top-sticky-button', 'js-scrollto', 'widget--base-shadow', 'is-hidden-S', 'custom-scroll-to-top', {
              'is-visible': _this2.state.showScrollTop
            }),
            "aria-label": phrase,
            onClick: scrollToTop
          });
        })));
      });
    }
  }]);
  return PoweredByInsided;
}(_preact.Component);

var _default = PoweredByInsided;
exports.default = _default;